/**
 * Stanlee Navigation — centralized category-link controller.
 *
 * This is the ONE place that turns a click anywhere on the site into
 * "scroll to Featured Products and switch to category X". Every
 * trigger that needs this behavior — the header's mega menu items,
 * the header's mobile accordion items, and the Hero's "Explore
 * Products" button — shares the exact same markup contract instead
 * of each having its own bespoke JS:
 *
 *   <a href="..." data-category-link data-category="android-tv">
 *
 * data-category must match a Featured Products tab's data-tab value:
 * "android-tv", "fire-tv", "webos-tv", "apple-tv", or "others".
 *
 * On click this file:
 *   1. Only intervenes if a Featured Products section (#products)
 *      exists on the current page — otherwise the link is left to
 *      navigate normally (e.g. a category link inside the header on
 *      the About page, where there's nothing to scroll to).
 *   2. Prevents the default navigation.
 *   3. Dispatches "stanlee:close-menus" so the header can close the
 *      mega menu / mobile menu (that DOM belongs to the header, so
 *      the header owns closing it — see stanlee-header.liquid).
 *   4. Smooth-scrolls to the Featured Products section.
 *   5. Dispatches "stanlee:activate-tab" with { category } so
 *      featured-products-tabs.js switches to the matching tab,
 *      highlights it, and swaps its hero image/heading/description
 *      and product grid — exactly as a manual tab click would.
 *
 * Loaded once, globally, from the header (present on every page), so
 * it also covers dynamically-injected sections re-rendered by the
 * Shopify theme editor via the shopify:section:load listener below.
 */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SCROLL_HEADER_OFFSET = 24;
  var SCROLL_DELAY_MS = 30; // gives "stanlee:close-menus" a moment to collapse any open menu first

  function scrollToProducts(target) {
    window.setTimeout(function () {
      var top = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_HEADER_OFFSET;
      window.scrollTo({ top: top, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    }, SCROLL_DELAY_MS);
  }

  function handleCategoryLinkClick(event) {
    var link = event.currentTarget;
    var category = link.getAttribute('data-category');
    var target = document.getElementById('products');

    // No category configured, or no Featured Products section on this
    // page (e.g. this header is rendered on a page without it) — let
    // the link behave like a normal <a> and navigate.
    if (!category || !target) return;

    event.preventDefault();

    document.dispatchEvent(new CustomEvent('stanlee:close-menus'));
    scrollToProducts(target);
    document.dispatchEvent(
      new CustomEvent('stanlee:activate-tab', { detail: { category: category } })
    );
  }

  function bindCategoryLinks(root) {
    (root || document).querySelectorAll('[data-category-link]').forEach(function (link) {
      if (link.dataset.stanleeNavBound) return;
      link.dataset.stanleeNavBound = 'true';
      link.addEventListener('click', handleCategoryLinkClick);
      // Keyboard/touch users get the same behavior via the native
      // click event that Enter/Space/tap already fire on an <a>.
    });
  }

  function init() {
    bindCategoryLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when the theme editor re-renders a section (header, hero,
  // etc.) so newly-inserted category links keep working without a
  // full page reload.
  document.addEventListener('shopify:section:load', function (event) {
    bindCategoryLinks(event.target);
  });
})();
